import { render, staticRenderFns } from "./index.vue?vue&type=template&id=351176ce&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/usr/src/app/components/common/Breadcrumb.vue').default,VideoPlayer: require('/usr/src/app/components/video/VideoPlayer.vue').default,Category: require('/usr/src/app/components/common/Category.vue').default,Search: require('/usr/src/app/components/common/Search.vue').default,VideoList: require('/usr/src/app/components/video/VideoList.vue').default,Pagination: require('/usr/src/app/components/common/Pagination.vue').default})
